import { render, staticRenderFns } from "./FileLoadingComponent.vue?vue&type=template&id=eb7e55ea&scoped=true"
import script from "./FileLoadingComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileLoadingComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FileLoadingComponent.vue?vue&type=style&index=0&id=eb7e55ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7e55ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb7e55ea')) {
      api.createRecord('eb7e55ea', component.options)
    } else {
      api.reload('eb7e55ea', component.options)
    }
    module.hot.accept("./FileLoadingComponent.vue?vue&type=template&id=eb7e55ea&scoped=true", function () {
      api.rerender('eb7e55ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/components/uploaderComponent/components/FileLoadingComponent.vue"
export default component.exports